<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter

========================================================================================== -->


<template functional>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <p>
      <span>COPYRIGHT &copy;</span>
      <span>{{ new Date().getFullYear() }}. All Rights Reserved. </span>
      <span class="hidden sm:inline-block"> Powered by Intellectual Point</span>
    </p>
    <span class="md:flex hidden items-center">
       <span class="hidden sm:inline-block"> Created with <font-awesome-icon class="text-danger mr-1 ml-1" :icon="['fas', 'heart']" />
         <!---<a href="" target="_blank" rel="nofollow"> Voriant  <font-awesome-icon :icon="['fab', 'canadian-maple-leaf']" /></a>--->
         by Cameron Mema
       </span>
    </span>
  </footer>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faHeart} from '@fortawesome/free-solid-svg-icons'

library.add(faHeart)

export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  }
}
</script>
